<template>
  <div class="w-full">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseForm',

  computed: {
    fields() {
      return (
        this.$children.filter(
          child => child.$options.name === 'BaseFormField'
        ) || []
      )
    }
  },

  methods: {
    defineIsValid() {
      const errors = this.fields.map(field => field.defineIsValid())

      return errors.every(Boolean)
    }
  }
}
</script>
